import { render, staticRenderFns } from "./Editar-Lembrete-Medicacao.vue?vue&type=template&id=33257527&"
import script from "./Editar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"
export * from "./Editar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editar-Lembrete-Medicacao.vue"
export default component.exports